<template>
    <v-container>
        <div style="width: 90%; font-size: 75%;">Got Token: {{ jwt }}</div>
        <code>{{ tokenInfo }}</code>
    </v-container>
</template>

<script>
    import {tokenUserInfo} from "../authentication";

    export default {
        name: "GetToken",
        props: {
            jwt: {
                required: true,
                type: String,
            }
        },
        computed: {
            tokenInfo () {
                return tokenUserInfo(this.jwt);
            }
        },
        created() {
            this.$store.commit('updateToken', this.jwt);
            if (this.$store.getters.isAuthenticated) {
                // getUserInfo(this.$store.getters.userInfo.id);
                this.$router.push({ name: 'home' });
            }
        }
    }
</script>

<style scoped>

</style>
